/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Trial_Days_ColInputs */

const en_admin_invite_codes_trial_days_col = /** @type {(inputs: Admin_Invite_Codes_Trial_Days_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial`)
};

const zh_admin_invite_codes_trial_days_col = /** @type {(inputs: Admin_Invite_Codes_Trial_Days_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用`)
};

/**
* | output |
* | --- |
* | "Trial" |
*
* @param {Admin_Invite_Codes_Trial_Days_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_trial_days_col = /** @type {((inputs?: Admin_Invite_Codes_Trial_Days_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Trial_Days_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_trial_days_col(inputs)
	return zh_admin_invite_codes_trial_days_col(inputs)
});
export { admin_invite_codes_trial_days_col as "admin.invite_codes.trial_days_col" }